import React from 'react';
import { usePageTitle } from '../hooks/usePageTitle';
import { photos } from '../data/site';
import { workshop } from '../data/content';
import { PageIntro } from '../components/ui/PageIntro';
import { ButtonLink } from '../components/ui/ButtonLink';
import { CtaBand } from '../components/ui/CtaBand';
export function Workshops() {
  usePageTitle('Ukelele-workshop');
  return <>
      <PageIntro eyebrow="Workshop · Speel de Uke" title={<>
            Anderhalf uur. <em className="text-amber" data-id="element-450" data-mp="1vrexkca2m84a">Eerste liedjes.</em>
          </>} intro="Op zoek naar een bedrijfsuitje, teambuilding of een leuke onderbreking op een verjaardag? In een gezellige groep leer je de ukelele spelen. Enige muzikale ervaring is niet nodig." image={{
      src: photos.ukulele,
      alt: 'Een ukelele in het gras voor een gele windmolen',
      position: '50% 55%'
    }} data-id="element-449" data-mp="20qrjmut4bb5t">
        <ButtonLink to="/contact?type=workshop" arrow data-id="element-451" data-mp="3h4q2jyzx7eta">
          Vraag naar de mogelijkheden
        </ButtonLink>
      </PageIntro>

      <section aria-labelledby="outcomes-title" className="w-full bg-paper text-ink" data-id="element-452" data-mp="23b7n3kblx8jo">
        <div className="mx-auto max-w-7xl px-5 py-24 md:px-10 lg:py-32" data-id="element-453" data-mp="28c51dlthxifw">
          <div className="grid grid-cols-1 gap-6 lg:grid-cols-12 lg:items-end" data-id="element-454" data-mp="1ubkm2zmsi4r5">
            <h2 id="outcomes-title" className="font-serif text-5xl leading-[1.02] tracking-tight md:text-6xl lg:col-span-7" data-id="element-455" data-mp="1zady0nmfhnp7">
              Na de workshop kun je…
            </h2>
            <p className="max-w-md text-[17px] leading-relaxed text-ink/70 lg:col-span-4 lg:col-start-9" data-id="element-456" data-mp="2n22w6klxl6e2">
              Muziek maken betekent ontspanning en plezier. In onze drukke levens is een instrument leren soms lastig — samen gaat het vanzelf.
            </p>
          </div>
          <ol className="mt-16 grid grid-cols-1 gap-10 md:grid-cols-3 md:gap-0" data-id="element-457" data-mp="2i7ovq3sew92j">
            {workshop.outcomes.map((o, i) => <li key={o.title} className="border-t border-ink/15 pt-6 md:pr-10" data-id="element-458" data-mp="35wznivrsat4j" data-mpi={i}>
                <p className="font-serif text-6xl italic leading-none text-amber-deep" data-id="element-459" data-mp="3aqvmo1jsam1a">{i + 1}</p>
                <h3 className="mt-6 text-lg font-semibold" data-id="element-460" data-mp="3kkrmvv1c6j2z">{o.title}</h3>
                <p className="mt-3 max-w-sm text-[16px] leading-relaxed text-ink/70" data-id="element-461" data-mp="3fnrhzng83mdg">{o.text}</p>
              </li>)}
          </ol>
        </div>
      </section>

      <section aria-labelledby="details-title" className="w-full bg-ink" data-id="element-462" data-mp="35os8k2nmvmpe">
        <div className="mx-auto grid max-w-7xl grid-cols-1 gap-14 px-5 py-24 md:px-10 lg:grid-cols-12 lg:items-center lg:py-32" data-id="element-463" data-mp="31motl41r9zzd">
          <div className="lg:col-span-6" data-id="element-464" data-mp="2wvox1zwjtjxe">
            <h2 id="details-title" className="font-serif text-5xl leading-[1.02] tracking-tight text-paper" data-id="element-465" data-mp="2wunmrxncx1gq">
              Praktisch
            </h2>
            <dl className="mt-10 border-t border-line" data-id="element-466" data-mp="2myar4u894djc">
              {workshop.details.map(d => <div key={d.label} className="grid grid-cols-2 gap-6 border-b border-line py-5" data-id="element-467" data-mp="2hyxvpl3bdy55">
                  <dt className="text-[15px] text-muted" data-id="element-468" data-mp="2dwuhwpt6ahgp">{d.label}</dt>
                  <dd className="text-[17px] text-paper" data-id="element-469" data-mp="tf25inryuo16">{d.value}</dd>
                </div>)}
            </dl>
            <p className="mt-10 text-sm text-muted" data-id="element-470" data-mp="xg43l1a5cu1k">Geschikt voor</p>
            <ul className="mt-3 flex flex-wrap gap-2" data-id="element-471" data-mp="xii0lfoe0gbr">
              {workshop.audiences.map(a => <li key={a} className="rounded-full border border-line px-4 py-2 text-sm text-sand" data-id="element-472" data-mp="17etci4k2f45o">
                  {a}
                </li>)}
            </ul>
          </div>
          <figure className="lg:col-span-5 lg:col-start-8" data-id="element-473" data-mp="9p87hrynrcoi">
            <img src={photos.ukePoster} alt="Poster van de workshop Speel de Uke" className="mx-auto w-full max-w-sm rounded-sm shadow-[0_24px_50px_rgba(0,0,0,0.55)]" data-id="element-474" data-mp="eqxkve9cs2fr" />
          </figure>
        </div>
      </section>

      <CtaBand title="Klinkt als muziek in de oren?" text="Vertel me voor welke groep en rond welke datum, dan denk ik graag met u mee." to="/contact?type=workshop" label="Plan een workshop" data-id="element-475" data-mp="oha32ztp3jiq" />
    </>;
}